import { Component, ElementRef, Input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import type { SwiperOptions } from 'swiper/types';
import { defaultImagePlaceholder } from '../../../constants/images.constants';
import { IImage } from '../../../core/interfaces/image';
import { SwiperContainer } from 'swiper/swiper-element';

@Component({
  selector: 'app-detail-gallery',
  templateUrl: './detail-gallery.component.html',
  styleUrls: ['./detail-gallery.component.scss'],
  standalone: false
})
export class DetailGalleryComponent implements OnInit, AfterViewInit {
  imagePlaceholder = defaultImagePlaceholder;
  maxSlidesNum = 2;

  @ViewChild('itemSwiper') itemSwiper: ElementRef<SwiperContainer>;

  @Input() showGalleryOnIconClick: boolean;
  @Input() classList: string;
  @Input() images: IImage[];
  @Input() index: number;
  @Input() title: string;
  @Input() adults: number;
  @Input() children: number;
  @Input() maxGuests: number;
  @Input() showMaxGuestsIcon: boolean;
  @Input() isHowItWorks: boolean = false;

  swiperConfig: SwiperOptions = {
    spaceBetween: 0,
    slidesPerView: 1,
    threshold: 6,
    pagination: {
      type: 'bullets',
      bulletElement: 'span',
      dynamicBullets: true,
      dynamicMainBullets: 1
    },
    navigation: true
  };

  // styles for navigation buttons
  public params: SwiperOptions = {
    injectStyles: [
      `
       :host .swiper-button-prev,
       :host .swiper-button-next {
          opacity: 0;
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: var(--neutral-off-white);
          border: 1px solid var(--secondary-50);
          color: var(--grayscale-900);
          border-radius: 10px;
          cursor: pointer;
          top: 50%;
          transform: translateY(-50%);
          margin: 0;
          font-size: 14px;
          font-family: 'Limehome' !important;
          speak: never;
          font-style: normal;
          font-weight: normal;
          font-variant: normal;
          text-transform: none;
          line-height: 1;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        :host .swiper-button-prev svg,
        :host .swiper-button-next svg {
          display: none
        }

        :host .swiper-button-prev::before {
          content: '\\2329';
        }

        :host .swiper-button-next::before {
          content: '\\232a';
        }

        :host .swiper:hover .swiper-button-prev:not(.swiper-button-disabled),
        :host .swiper:hover .swiper-button-next:not(.swiper-button-disabled) {
          opacity: 1;
        }

        :host .swiper:hover .swiper-button-prev.swiper-button-disabled,
        :host .swiper:hover .swiper-button-next.swiper-button-disabled {
          opacity: 0.5;
          pointer-events: auto;
        }
      `
    ]
  };

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.itemSwiper?.nativeElement.addEventListener('swiperslidechange', (event) => {
      this.addAllSlides();
    });
  }
  addAllSlides() {
    if (this.maxSlidesNum !== this.images.length - 1) {
      this.maxSlidesNum = this.images.length - 1;
      setTimeout(() => {
        this.itemSwiper?.nativeElement.swiper.update();
      });
    }
  }
}
